module.exports = __webpack_public_path__ + "static/media/WIDE.6624b945.svg";